import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Dostawca menu',
      options: {
        [null]: 'Wybierz dostawcę menu',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Inna restauracja Foodamigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL Lieferando',
        placeholder: 'URL restauracji w Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL Wolt',
        placeholder: 'URL restauracji w Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Link do restauracji w Deliveroo',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Otwórz swoją restaurację na Deliveroo i skopiuj link z paska adresu.',
        error:
          'Wprowadź link do strony menu restauracji w Deliveroo. Wygląda tak: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'URL Uber Eats',
        placeholder: 'URL restauracji w Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Link GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Jeśli korzystasz ze strony zamówień GloriaFood:',
            description: 'Wprowadź swój adres URL zamówień foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Jeśli GloriaFood jest osadzony na Twojej własnej stronie:',
            description: 'Wprowadź adres URL strony w Twojej witrynie, na której wyświetla się widget zamówień.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Wprowadź prawidłowy link zaczynający się od https://.',
        back_office_error:
          'To jest link do panelu administracyjnego GloriaFood, a nie strona, z której zamawiają Twoi klienci. Otwórz stronę zamówień swojej restauracji i wklej ten link.',
        wrong_platform_error:
          'To nie wygląda na link GloriaFood. Jeśli korzystasz ze strony zamówień hostowanej przez GloriaFood, wprowadź swój adres URL zamówień foodbooking.com. Jeśli GloriaFood jest osadzony na Twojej własnej stronie, wprowadź adres URL strony, na której wyświetla się Twój widget zamówień.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL Thuisbezorgd',
        placeholder: 'URL restauracji w Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL Takeaway.com',
        placeholder: 'URL restauracji w Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL Pyszne.pl',
        placeholder: 'URL restauracji w Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL Bistro.sk',
        placeholder: 'URL restauracji w Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL Just Eat',
        placeholder: 'URL restauracji w Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Link do restauracji w DoorDash',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Otwórz swoją restaurację na doordash.com i skopiuj link z paska adresu.',
        error: 'Wprowadź link do strony restauracji w DoorDash. Zaczyna się od https://www.doordash.com/store/.',
        store_number_error:
          'Ten link zawiera tylko numer sklepu. Otwórz restaurację na doordash.com i skopiuj link z jej nazwą, np. https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restauracja, z której skopiować menu',
        placeholder: 'Wybierz restaurację, z której skopiować menu',
      },
    },
  },
};
